let onLoad = function (){
  let fadeItems = document.querySelectorAll('main .shopify-section');
  for (let i = 0; i < fadeItems.length; i++) {
      let scrollY = window.scrollY; 
      let windowHeight = window.innerHeight; 
      let topline = fadeItems[i].getBoundingClientRect().top + window.scrollY;
      let bottomline = fadeItems[i].getBoundingClientRect().bottom + window.scrollY; 
      if (topline - windowHeight + (windowHeight * 0.2) < scrollY) {
        fadeItems[i].classList.add('visible');
      };
  };
  let scroll = function () {
    for (let i = 0; i < fadeItems.length; i++) {
      let scrollY = window.scrollY; 
      let windowHeight = window.innerHeight; 
      let topline = fadeItems[i].getBoundingClientRect().top + window.scrollY;
      let bottomline = fadeItems[i].getBoundingClientRect().bottom + window.scrollY; 
      if (topline - windowHeight + (windowHeight * 0.2) < scrollY) {
        fadeItems[i].classList.add('visible');
      };
    };
  }
  window.addEventListener('scroll', scroll);
}
window.addEventListener('load', onLoad);